// ── GQ Supabase Client ────────────────────────────────────────────────
// Connects via the @supabase/supabase-js UMD bundle (loaded as a <script> in
// index.html). Vite replaces `import.meta.env.VITE_*` at build time. The
// hardcoded fallbacks below match the dev project and are safe to ship — the
// anon key is intentionally public and gated by RLS — but production builds
// should set VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY in CF Pages env.

const GQ_SUPABASE_URL =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SUPABASE_URL) ||
  "https://aeapstujazvrwaqiuvmo.supabase.co";
const GQ_SUPABASE_KEY =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SUPABASE_ANON_KEY) ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFlYXBzdHVqYXp2cndhcWl1dm1vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg3NzM0NDUsImV4cCI6MjA5NDM0OTQ0NX0.0cQMqtZb9nn-Gw2-n_I9uahzcnPIPvYEckdZMMm6gIs";

// createClient is exposed by the CDN script as window.supabase.createClient
const sbClient = window.supabase.createClient(GQ_SUPABASE_URL, GQ_SUPABASE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

window.sbClient = sbClient;

// ── Auth helpers ──────────────────────────────────────────────────────
window.gqAuth = {
  async getSession() {
    const { data: { session } } = await sbClient.auth.getSession();
    return session;
  },
  async getUser() {
    const { data: { user } } = await sbClient.auth.getUser();
    return user;
  },
  async getRole(userId) {
    if (!userId) return null;
    const { data } = await sbClient
      .from('user_roles')
      .select('role')
      .eq('user_id', userId)
      .single();
    return data?.role || null;
  },
  async signIn(email, password) {
    return sbClient.auth.signInWithPassword({ email, password });
  },
  async signOut() {
    return sbClient.auth.signOut();
  },
  async resetPassword(email) {
    return sbClient.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + '/app/auth.html',
    });
  },
  async submitAccessRequest({ email, full_name, company, reason, user_id }) {
    return sbClient.from('access_requests').insert({ email, full_name, company, reason, user_id });
  },
  // Guard: redirect to auth if no session, redirect to pending if role=pending
  async guard(redirectAuth = 'auth.html', redirectPending = 'pending.html') {
    const session = await this.getSession();
    if (!session) { window.location.href = redirectAuth; return null; }
    const role = await this.getRole(session.user.id);
    if (!role || role === 'pending') { window.location.href = redirectPending; return null; }
    return { user: session.user, role };
  }
};

// ── SQL setup script (run once in Supabase SQL editor) ────────────────
// See app/SETUP.sql for the complete schema migrations to run.
console.log('[GQ] Supabase client ready →', GQ_SUPABASE_URL);
